module.exports = __webpack_public_path__ + "static/media/solar-panel3.830a72d8.jpg";